import GenericModel from '../../generic-model';

export default class StickerPart extends GenericModel {
  stickerWidth?: number;
  stickerHeight?: number;
  windowWidth?: number;
  windowHeight?: number;
  description?: string;
  constructor() {
    super();
  }

  public canSubmitAsClient(): boolean {
    return (
      this.stickerWidth != null &&
      this.stickerHeight != null &&
      this.windowWidth != null &&
      this.windowHeight != null
    );
  }
}

// constructor comparison should be enough for now since the only context where we need this
// right now is when a client is ordering a new project
export function isStickerPart(obj: any): obj is StickerPart {
  return obj != null && obj.constructor === StickerPart.prototype.constructor;
}
